import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Select,
  Upload,
  Button,
  Row,
  Col,
  message,
  Card,
  Modal,
  DatePicker,
  InputNumber,
  Radio,
  Checkbox,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { ArrowUpFromLine, Trash2, Users } from "lucide-react";
import { useLocation, useNavigate } from "react-router";
import CheckBigImage from "../../assets/images/newimages/check-big-Image.svg";
import DownloadImage from "../../assets/images/newimages/download-line.svg";
import CopylinkImage from "../../assets/images/newimages/file-copy-line.svg";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import moment from "moment";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
const { Option } = Select;

const TqForLeaderform = () => {
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { request } = useRequest();
  const location = useLocation();
  const [distributionType, setDistributionType] = useState("Platform");
  const [teamSize, setTeamSize] = useState(0);
  const [formAction, setFormAction] = useState(null);
  const [surveyLink, setSurveyLink] = useState("");
  const [surveyId, setSurveyId] = useState(null);
  const [leaderSurveyLink, setLeaderSurveyLink] = useState("");
  const [value, setValue] = useState("");

  useEffect(() => {
    form.setFieldsValue({
      draft: `<p><span style="color: rgb(33, 33, 33); background-color: transparent;">Greetings from TEAM INTELLIGENCE HUB</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">We are reaching out as part of a team development program.</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">We are seeking your support to complete a team survey aimed at gaining insights into your team’s dynamics. Your input is important in helping us better&nbsp;understand&nbsp;the dynamics and individual challenges of the team.</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;</span></p><p>{{LINK}}</p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">The survey should take 10 minutes at most. Your responses will remain anonymous&nbsp;and will contribute to&nbsp;further strengthen and ensure your team’s continued effectiveness and success.&nbsp;</span></p><p><br></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">Please complete the survey by {{DEADLINE}}</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">Thank you for your participation in this effort to&nbsp;enhance&nbsp;your team’s performance.</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;&nbsp;</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">TEAM INTELLIGENCE HUB</span></p><p><br></p>`,
      draftMember: `<p><span style="color: rgb(33, 33, 33); background-color: transparent;">Greetings from TEAM INTELLIGENCE HUB</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">We are reaching out as part of a team development program.</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">We are seeking your support to complete a team survey aimed at gaining insights into your team’s dynamics. Your input is important in helping us better&nbsp;understand&nbsp;the dynamics and individual challenges of the team.</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;</span></p><p>{{LINK}}</p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">The survey should take 10 minutes at most. Your responses will remain anonymous&nbsp;and will contribute to&nbsp;further strengthen and ensure your team’s continued effectiveness and success.&nbsp;</span></p><p><br></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">Please complete the survey by {{DEADLINE}}</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">Thank you for your participation in this effort to&nbsp;enhance&nbsp;your team’s performance.</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;&nbsp;</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">TEAM INTELLIGENCE HUB</span></p><p><br></p>`,
    });
  }, [value]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const members = params.get("members");
    const id = params.get("surveyId");

    if (members) {
      form.setFieldsValue({
        teamSize: Number(members),
      });
    }
    if (id) {
      setSurveyId(id);
      fetchSurveyData(id);
    }
  }, [location]);

  const onFinish = async (values) => {
    console.log("Form Values:", values);
    console.log("Action:", formAction);

    if (values.teamSize < 3) {
      return ShowToast("Please add at least three member!", "error");
    }

    if (distributionType === "Platform") {
      const invalidMembers = values.members?.filter(
        (mem) => !mem?.name || !mem?.email
      );
      if (invalidMembers?.length > 0) {
        return ShowToast(
          "Please enter name and email for each member!",
          "error"
        );
      }
    } else {
      const invalidMembers = values.members?.filter((mem) => !mem?.name);
      if (invalidMembers?.length > 0) {
        return ShowToast("Please enter name of each member!", "error");
      }
    }

    try {
      setLoading(true);

      const payload = {
        surveyType: "Leader",
        teamName: values.teamName,
        leader: {
          name: values.teamLeaderName,
          email: values.teamLeaderEmail,
        },
        language: values.language,
        teamSize: values.teamSize,
        members: values.members || [],
        country: values.country,
        industry: values.industry,
        teamRole: values.teamRole,
        businessUnit: values.businessUnit,
        paymentType: "Credit",
        companySize: values.companySize,
        openQuestions: [
          values.question1,
          values.question2,
          values.question3,
          values.question4,
        ].filter(Boolean),
        deadline: values.targetDeadline,
        emailTemplate: values.draft,
        emailTemplates: {
          memberTemplate: values.draftMember,
          leaderTemplate: values.draft,
        },
        distributionMethod: distributionType,
        gdprConsent: values.gdprConsent,
        status: formAction === "launch" ? "Open" : "Review",
      };

      console.log("Submitting payload:", surveyId, payload);
      const config = {
        url: surveyId
          ? `/admin/mf/survey/update/${surveyId}`
          : "/admin/mf/survey/create",
        method: surveyId ? "PUT" : "POST",
        data: payload,
      };

      console.log("Request Config:", config);
      request({
        url: config.url,
        data: payload,
        method: config.method,
        onSuccess: (data) => {
          console.log(data, "data here");
          if (formAction === "review") {
            ShowToast("Survey details saved for review", Severty.SUCCESS);
            navigate("/tqforleader");
          } else if (formAction === "launch") {
            ShowToast(
              data?.message || "Survey created successfully!",
              Severty.SUCCESS
            );
            setIsModalVisible(true);
          }
          setSurveyLink(data?.data?.surveyLink || "");
          setLeaderSurveyLink(data?.data?.surveyLeaderLink || "");
          setIsModalVisible(formAction === "launch");
          setLoading(false);
        },
        onError: (error) => {
          console.log(error, "error onErorr");
          ShowToast(
            error.response?.data?.message || "Failed to Create Survey",
            Severty.ERROR
          );
          setLoading(false);
        },
      });
    } catch (err) {
      console.error(err, "here error");
      message.error(err.response?.data?.message || "Survey creation failed");
    }
  };

  const fetchSurveyData = async (id) => {
    setLoading(true);
    try {
      request({
        url: `/admin/mf/survey/getSurvey/${id}`,
        method: "GET",
        onSuccess: (data) => {
          const surveyData = data;
          if (surveyData.deadline) {
            surveyData.targetDeadline = moment(surveyData.deadline);
          }
          console.log(surveyData, "surveyData");
          const mappedData = {
            ...surveyData,
            teamLeaderName: surveyData.leader?.name || "",
            teamLeaderEmail: surveyData.leader?.email || "",
            draftMember: surveyData.emailTemplates?.memberTemplate || "",
            draft: surveyData.emailTemplates?.leaderTemplate || "",
            members:
              surveyData.members?.map((m) => ({
                name: m.name,
                email: m.email,
              })) || [],
          };
          form.setFieldsValue(mappedData);

          // form.setFieldsValue({
          //   ...surveyData,
          //   // openQuestions: surveyData.openQuestions,
          // });
          setTeamSize(surveyData.teamSize);
          setDistributionType(surveyData.distributionMethod || "Platform");
        },
        onError: (error) => {
          ShowToast(
            error.response?.data?.message || "Failed to Fetch Survey",
            Severty.ERROR
          );
          setLoading(false);
        },
      });
    } catch (err) {
      ShowToast(
        err.response?.data?.message || "Failed to load survey data",
        Severty.ERROR
      );
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleModalCloseAndNavigate = () => {
    setIsModalVisible(false);
    navigate("/tqforleader");
    form.resetFields();
  };

  const handleCopyLink = async () => {
    // if (!surveyLink) {
    //   message.error("No survey link available!");
    //   return;
    // }
    try {
      await navigator.clipboard.writeText(surveyLink);
      message.success("Survey link copied!");
    } catch (err) {
      message.error("Failed to copy link.");
    }
  };

  const handleCopyTeamLink = async () => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(surveyLink);
        message.success("Team link copied!");
        return;
      }
      const textArea = document.createElement("textarea");
      textArea.value = surveyLink;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          message.success("Team link copied!");
        } else {
          message.error("Failed to copy link. Please copy manually.");
        }
      } catch (err) {
        console.error('Fallback copy error:', err);
        message.error("Failed to copy link. Please copy manually.");
      } finally {
        document.body.removeChild(textArea);
      }
    } catch (err) {
      console.error('Copy error:', err);
      const userCopy = prompt("Please copy the link manually:", surveyLink);
      if (userCopy !== null) {
        message.info("Link displayed for manual copy");
      }
    }
  };

  const handleCopyLeaderLink = async () => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(leaderSurveyLink);
        message.success("Leader link copied!");
        return;
      }
      const textArea = document.createElement("textarea");
      textArea.value = leaderSurveyLink;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          message.success("Leader link copied!");
        } else {
          message.error("Failed to copy link. Please copy manually.");
        }
      } catch (err) {
        console.error('Fallback copy error:', err);
        message.error("Failed to copy link. Please copy manually.");
      } finally {
        document.body.removeChild(textArea);
      }
    } catch (err) {
      console.error('Copy error:', err);
      const userCopy = prompt("Please copy the link manually:", leaderSurveyLink);
      if (userCopy !== null) {
        message.info("Link displayed for manual copy");
      }
    }
  };

  const handleDownloadLink = () => {
    // if (!surveyLink) {
    //   message.error("No survey link available!");
    //   return;
    // }
    const content = `Team Survey Link: ${surveyLink}\n\nLeader Survey Link: ${leaderSurveyLink}`;

    const element = document.createElement("a");
    const file = new Blob([content], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "tps-survey-link.txt";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <div className="purchase-survey-cards-main">
      <Card className="purchase-survey-cards">
        <div className="purchase-survey-cards-header-main mb-3">
          <h4 className="purchase-survey-cards-header">
            <Users /> Setup TPS for Teams Survey
          </h4>
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          // onFinish={(values) => handleFinish(values, actionType)}

          onFinishFailed={onFinishFailed}
          initialValues={{ tags: ["emailDisplay"] }}
        >
          <Row gutter={16}>
            <Col span={24} md={12}>
              <Form.Item
                label="Language for survey and report"
                name="language"
                rules={[{ required: true }]}
              >
                {/* <Input placeholder="Language for survey and report" /> */}
                <Select placeholder="Select language">
                  <Option value="en">English</Option>
                  <Option value="fr">French</Option>
                  <Option value="de">German</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={24} md={12}>
              <Form.Item
                label="Team Leader Name"
                name="teamLeaderName"
                rules={[{ required: true }]}
              >
                <Input placeholder="Enter team leader name" />
              </Form.Item>
            </Col>

            <Col span={24} md={12}>
              <Form.Item
                label="Number of team members (including team leader)"
                name="teamSize"
                rules={[{ required: true }]}
              >
                <InputNumber
                  min={1}
                  // max={12}
                  value={teamSize}
                  onChange={setTeamSize}
                  // style={{ width: "100%" }}
                />
                {/* <Input placeholder="Enter number of team members" /> */}
              </Form.Item>
            </Col>

            <Col span={24} md={12}>
              <Form.Item
                label="Country"
                name="country"
                rules={[{ required: true }]}
              >
                <Select placeholder="Select country">
                  <Option value="india">India</Option>
                  <Option value="usa">USA</Option>
                  <Option value="uk">UK</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={24} md={12}>
              <Form.Item label="Industry" name="industry">
                <Select placeholder="Select industry">
                  {industries.map((ind) => (
                    <Option key={ind} value={ind}>
                      {ind}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={24} md={12}>
              <Form.Item label="Team Role" name="teamRole">
                <Select placeholder="Select team role">
                  {roles.map((role) => (
                    <Option key={role} value={role}>
                      {role}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={24} md={12}>
              <Form.Item label="Business Unit" name="businessUnit">
                <Select placeholder="Select business unit">
                  <Option value="customerService">
                    Customer Service / Support
                  </Option>
                  <Option value="engineering">Engineering / Technical</Option>
                  <Option value="executive">
                    Executive / General Management
                  </Option>
                  <Option value="finance">Finance / Accounting</Option>
                  <Option value="hr">Human Resources (HR)</Option>
                  <Option value="it">
                    Information Technology (IT) / Systems
                  </Option>
                  <Option value="legal">Legal / Compliance</Option>
                  <Option value="marketing">Marketing / Communications</Option>
                  <Option value="operations">
                    Operations / Supply Chain / Logistics
                  </Option>
                  <Option value="product">Product Management</Option>
                  <Option value="quality">Quality / Health & Safety</Option>
                  <Option value="rnd">Research & Development (R&D)</Option>
                  <Option value="sales">Sales / Business Development</Option>
                  <Option value="strategy">
                    Strategy / Corporate Development
                  </Option>
                  <Option value="other">Other</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={24} md={12}>
              <Form.Item label="Company Size" name="companySize">
                <Select placeholder="Select company size">
                  <Option value="small">1-50</Option>
                  <Option value="medium">51-200</Option>
                  <Option value="large">201+</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item label="Survey Distribution Method">
                <Radio.Group
                  onChange={(e) => setDistributionType(e.target.value)}
                  value={distributionType}
                >
                  <Radio value="Platform">send emails & reminders</Radio>
                  <Radio value="Manual">send manual link</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            {distributionType === "Platform" && (
              <Form.Item
                name="gdprConsent"
                valuePropName="checked"
                rules={[
                  {
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject("Please provide GDPR consent");
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Checkbox>I confirm GDPR consent for sending emails</Checkbox>
              </Form.Item>
            )}

            <Col span={24} md={12}>
              <Form.Item
                label="Team Name"
                name="teamName"
                rules={[{ required: true }]}
              >
                <Input placeholder="Enter unique team name" />
              </Form.Item>
            </Col>

            <Col span={24} md={12}>
              <Form.Item
                label="Team Leader Email"
                name="teamLeaderEmail"
                rules={[{ required: true }]}
              >
                <Input placeholder="Enter Team Leader Email" />
              </Form.Item>
            </Col>
          </Row>

          {/* Team Members Section */}
          {distributionType === "Platform" ? (
            <Form.List name="members">
              {(fields, { add, remove }) => (
                <>
                  <div className="add-team-men-mbers-main">
                    <h5>Team Members (Email only)</h5>
                    <Row
                      gutter={[12, 12]}
                      align="middle"
                      style={{ marginBottom: 16 }}
                    >
                      <Col>
                        <Form.Item name="upload" noStyle>
                          <Upload
                            beforeUpload={() => false}
                            showUploadList={false}
                          >
                            <Button icon={<ArrowUpFromLine />}>
                              Upload Excel
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                      <Col>
                        <Button
                          icon={<PlusOutlined />}
                          onClick={() => add()}
                          type="primary"
                        >
                          Add Member
                        </Button>
                      </Col>
                    </Row>
                  </div>

                  {fields.map((field) => (
                    <Row
                      key={field.key}
                      gutter={[12, 12]}
                      align="middle"
                      style={{ marginBottom: 12 }}
                    >
                      <Col flex="auto">
                        <Form.Item
                          {...field}
                          name={[field.name, "email"]}
                          noStyle
                          rules={[
                            { required: true, message: "Enter email" },
                            { type: "email", message: "Invalid email" },
                          ]}
                        >
                          <Input placeholder="Member email" />
                        </Form.Item>
                      </Col>
                      <Col>
                        <Button
                          type="text"
                          onClick={() => remove(field.name)}
                          className="delete-button-binn"
                        >
                          <Trash2 />
                        </Button>
                      </Col>
                    </Row>
                  ))}
                </>
              )}
            </Form.List>
          ) : (
            <div className="add-team-men-mbers-main">
              <h5>No team member emails are required for manual distribution</h5>
              <p style={{ marginTop: 8, color: "#4d4d4f" }}>
                Manual distribution will generate a team survey link for the full
                team. Only the team leader details are required.
              </p>
            </div>
          )}

          <Form.Item name="targetDeadline" label="Target Deadline">
            <DatePicker
              style={{ width: "100%" }}
              disabledDate={(current) => {
                // Disable dates before today
                return current && current < moment().startOf("day");
              }}
            />
          </Form.Item>

          {/* <Form.Item
            name="draft"
            label="Email Template (Team Leader)"
            // rules={[{ required: true }]}
          >
            <CKEditor
            editor={ ClassicEditor }
              data={form.getFieldValue("draft") || ""}
              onChange={(event, editor) => {
                const data = editor.getData();
                form.setFieldsValue({ draft: data });
              }}
            />
          </Form.Item>

          <Form.Item
            name="draftMember"
            label="Email Template (Team Members)"
            // rules={[{ required: true }]}
          >
            <CKEditor
            editor={ ClassicEditor }
              data={form.getFieldValue("draftMember") || ""}
              onChange={(event, editor) => {
                const data = editor.getData();
                form.setFieldsValue({ draftMember: data });
              }}
            />
          </Form.Item> */}

          <Form.Item name="draft" label="Email Template (Team Leader)">
            <ReactQuill
              theme="snow"
              value={value}
              onChange={setValue}
              placeholder="Enter Email Template..."
              style={{ height: "250px", marginBottom: "40px" }}
            />
          </Form.Item>

          <Form.Item name="draftMember" label="Email Template (Team Members)">
            <ReactQuill
              theme="snow"
              value={value}
              onChange={setValue}
              placeholder="Enter Email Template..."
              style={{ height: "250px", marginBottom: "40px" }}
            />
          </Form.Item>

          <div className="modal-footer-main">
            <Button disabled={loading} type="link" onClick={() => navigate(-1)}>
              Back
            </Button>
            {/* <Button
              type="default"
              htmlType="submit"
              onClick={() => setFormAction("review")}
              loading={loading && formAction === "review"}
            >
              Review
            </Button> */}
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => setFormAction("launch")}
              loading={loading}
            >
              Launch TPS Survey
            </Button>
          </div>
        </Form>
      </Card>

      {/* Success Modal */}
      <Modal
        open={isModalVisible}
        // onCancel={() => {
        //   setIsModalVisible(false)
        //   navigate("/tqforleader");
        // }}

        onCancel={handleModalCloseAndNavigate}
        footer={null}
        centered
        closable={false}
        width={540}
        bodyStyle={{ textAlign: "center", padding: 24 }}
      >
        <div className="members-modal-main members-modal-main-check">
          <div className="question-mark-image">
            <img src={CheckBigImage} alt="Question Mark" />
          </div>
          {distributionType === "Platform" ? (
            <>
              <h4>Invitation Sent Successfully!</h4>
              <h6>
                Your TPS survey has been sent to all team members via email. <br />
                You can also copy the Survey link below.
              </h6>
              <div className="cpoy-link-button" onClick={handleCopyLink}>
                <img src={CopylinkImage} alt="copy" /> Copy Link
              </div>
            </>
          ) : (
            <>
              <h4>Survey Links Generated!</h4>
              <h6>Please distribute these links manually.</h6>
              {surveyLink && (
                <div style={{ marginBottom: 16, textAlign: "left" }}>
                  <p><strong>Team Members Link:</strong></p>
                  <div className="modal-footer-main">
                    <div className="cpoy-link-button" onClick={handleCopyTeamLink}>
                      <img src={CopylinkImage} alt="copy" style={{ width: 16 }} />Copy
                    </div>
                  </div>
                </div>
              )}
              {leaderSurveyLink && (
                <div style={{ marginBottom: 16, textAlign: "left" }}>
                  <p><strong>Team Leader Link:</strong></p>
                  <div className="modal-footer-main">
                    <div className="cpoy-link-button" onClick={handleCopyLeaderLink}>
                      <img src={CopylinkImage} alt="copy" style={{ width: 16 }} />Copy
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
          <div className="modal-footer-main">
            <Button onClick={handleModalCloseAndNavigate} type="link">
              Cancel
            </Button>
            <Button type="primary" onClick={handleDownloadLink}>
              <img src={DownloadImage} alt="download" /> Download Link
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default TqForLeaderform;

const industries = [
  "Agriculture, Forestry, Mining and Fishing",
  "Construction and Real Estate",
  "Consulting Services",
  "Education and Research",
  "Finance and Insurance",
  "Healthcare and Life Sciences",
  "Information Technology and Telecommunications",
  "Manufacturing and Industrial Production",
  "Public Sector and Nonprofit",
  "Retail, Wholesale, and Consumer Goods",
  "Transportation, Logistics, and Travel",
  "Other",
];

const roles = [
  "Customer Service / Support",
  "Engineering / Technical",
  "Executive / General Management",
  "Finance / Accounting",
  "Human Resources (HR)",
  "Information Technology (IT) / Systems",
  "Legal / Compliance",
  "Marketing / Communications",
  "Operations / Supply Chain / Logistics",
  "Product Management",
  "Quality / Health & Safety",
  "Research & Development (R&D)",
  "Sales / Business Development",
  "Strategy / Corporate Development",
  "Other",
];
